import React, { useState, useEffect } from "react";
import './style.scss';
import { PageHeader, Layout, Table } from 'antd';
import OrderService from "../../services/OrderService";
import { useHistory } from "react-router";
import R2Footer from "../../components/Footer";
import AddCatering from "./AddCatering";
import CateringDetails from "./CateringDetail";

const { Content } = Layout;



const Catering = () => {
    const [loading, setLoading] = useState(false);
    const [orders, setOrders] = useState([]);
    const [addModal, setAddModal] = useState(false);
    const [isEdit, setEdit] = useState(false);
    const [updatedCatering, setUpdatedCatering] = useState();
    const history = useHistory();

    const columns = [
        {
            title: 'Customer Name',
            dataIndex: 'time_zone',
            render: (_, record) =>
            orders.length >= 1 ? (
              <div>{record.customer.name}</div>
            ) : null,
           
        },
        {
            title: 'Pickup Date',   
            dataIndex: 'catering_pickup_date',
            key: 'catering_pickup_date'
        },
        {
            title: 'Status',   
            dataIndex: 'is_approved',
            key: 'is_approved',
            render: (text) => <b style={{ color: text?'#52c41a':'#e18b8b' }}>{text?"Approved":"Waiting for approval"}</b>
        },
        {
            title: 'Event Details',       
            dataIndex: 'event_details',
            key: 'event_details' 
        },
        {
            title: 'Event Time',  
            dataIndex: 'event_time',
            key: 'event_time',
            
        },
        {
            title: 'Event Type',       
            dataIndex: 'event_type',
            key: 'event_type' 
        },
        
    ];

    useEffect(() => {
        getOrders();
        // return () => {
        //     cleanup
        // }
    }, [])

    const closeModal =(status)=>{
        setAddModal(status)
        getOrders();
    }

    const getOrders = async () => {
        const data = await OrderService.getCaterings();
        setOrders(data.catering_requests);
    }

    return (
        <Layout className="u-page-layout">
        <Content
            className="site-layout-background"
        >
            <PageHeader
                title="Catering"
                onBack={() => history.goBack()}
            />
            {/* <div className="menu-bar">
                        <Button className="success" onClick={()=>{
                            setEdit(false)
                            setAddModal(true)}}>Add Catering</Button>
                    </div> */}
            <Table columns={columns} dataSource={orders} onRow={(order) => {
                return {
                    onClick: event => {
                        // setEdit(false)
                        //     setAddModal(true)
                        //     setUpdatedCatering(order)
                        history.push(`/catering-details/${order.id}`)
                    }
                }
            }} />
            {addModal &&
            <CateringDetails modalOpen={true} isEdit={isEdit} closeModal={closeModal} updatedCatering={updatedCatering}/>}
        </Content>
        <R2Footer/>
    </Layout>
    )
}

export default Catering;
